








import {Vue, Component, Prop} from 'vue-property-decorator';
import ModalIframe from '@/components/iframe/ModalIframe.vue';

@Component({ components: { ModalIframe } })
export default class OtpSettingIframe extends Vue {
  @Prop() private showFlg!: boolean;
  private closePopup() {
    this.$emit('update:showFlg', false);
  }

  private get remoteSrc() {
    const query = this.$route.query;
    const queryObject = { ...query, serviceType: 'PREMIUM' };
    const queryString = new URLSearchParams(queryObject).toString();

    return process.env.VUE_APP_ADMIN_REMOTE_URL + '/popup/otp-setting?' + queryString;
  }
    private receiveMessage(e: MessageEvent) {
    if (e.data.closeOtpSetting || e.data.otpSettingComplete) {
      this.closePopup()
      return;
    }
  }

  mounted() {
    window.addEventListener('message', this.receiveMessage);
  }

  beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage);
  }
}
